export default __webpack_public_path__ + "static/media/servico-placeholder.d364522f.png";